export const mealPlaceholderImage = (mealType: number, appBrand: string) => {
  let mealImg = '';

  const appBrandWithApendix = appBrand === 'dtba' ? 'dl-space.fra1' : `${appBrand}.sfo2`;
  switch (mealType) {
    case 1:
      mealImg = `https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/meal-plan/breakfastPlaceholderImg.png`;
      break;
    case 2:
      mealImg = `https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/meal-plan/morningSnackPlaceholderImg.png`;
      break;
    case 3:
      mealImg = `https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/meal-plan/dinnerPlaceholderImg.png`;
      break;
    case 4:
      mealImg = `https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/meal-plan/eveningSnackPlaceholderImg.png`;
      break;
    case 5:
      mealImg = `https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/meal-plan/supperPlaceholderImg.png`;
      break;
    case 6:
      mealImg = `https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/meal-plan/snackPlaceholderImg.png`;
      break;
    case 7:
      mealImg = `https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/meal-plan/lunchPlaceholderImg.png`;
      break;
    case 8:
      mealImg = `https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/meal-plan/dinnerPlaceholderImg.png`;
      break;
    case 9:
      mealImg = `https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/meal-plan/snackPlaceholderImg.png`;
      break;
    default:
      mealImg = `https://${appBrandWithApendix}.cdn.digitaloceanspaces.com/meal-plan/breakfastPlaceholderImg.png`;
  }

  return mealImg;
};
